import { z } from "zod";
import { CONTENT_SCOPES } from "./content.js";
import { RESOLUTION_LEVELS } from "./portal-selection.js";
export const effectiveCandidateSchema = z.object({
    contentId: z.string(),
    title: z.string(),
    scope: z.enum(CONTENT_SCOPES),
    level: z.enum(RESOLUTION_LEVELS),
    priority: z.number().int(),
    publishedAt: z.string(),
});
export const effectiveWinnerSchema = effectiveCandidateSchema.extend({
    reason: z.string(),
    consideredAtLevel: z.array(effectiveCandidateSchema),
});
export const effectiveContentResponseSchema = z.object({
    siteId: z.string(),
    siteCode: z.string(),
    organizationId: z.string(),
    resolutionOrder: z.array(z.string()),
    announcement: effectiveWinnerSchema.nullable(),
    promotion: effectiveWinnerSchema.nullable(),
    sponsored: effectiveWinnerSchema.nullable(),
    /** True when CMS has no winner — portal should use local fallback. */
    localFallbackSuggested: z.boolean(),
    /** C4B: platform kill switch forces null remote display fields (auth/local assets untouched). */
    killSwitchActive: z.boolean(),
});
export const resolveOverlapsSchema = z.object({
    mappings: z
        .array(z.object({
        siteId: z.string().min(1),
        keepGroupId: z.string().min(1),
    }))
        .min(1),
});
//# sourceMappingURL=effective-content.js.map